import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'El contador define en qué unidad se mide el uso del equipo: horas para maquinaria, kilómetros para vehículos.',
    'Cada equipo se lee según su contador, y sobre esa lectura se calculan los vencimientos de mantenimiento.',
    'Cambiar el contador de un equipo ya en uso altera cómo se proyectan sus próximos servicios: revisalo antes.',
  ],
  nextSteps: [
    'Asignar el contador correspondiente a cada equipo desde su ficha.',
    'Cargar las lecturas periódicas mediante los partes diarios.',
  ],
};

const ConfiguracionTiposContador = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="tiposcontador"
      titulo="Tipos de Contador"
      descripcion="Configuración de contadores (Hs, Km, etc.)"
      icon="fas fa-stopwatch"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionTiposContador;
